import { Link } from 'react-router-dom';
import { Bell, ShoppingCart, MessageCircle, Sparkles, Mic2 } from 'lucide-react';
import { UserDropdown } from './UserDropdown';

export function DesktopNav({ user, isAuthenticated, isAdmin, isArtist, isAgent, showCart, cart, dashboardLink, notifCount, inboxCount, onLogout }) {
  return (
    <div className="hidden md:flex items-center gap-6">
      {isAgent && <Link to="/agent-dashboard" className="text-sm text-[#A1A1AA] hover:text-white transition-colors" data-testid="nav-agent-dashboard-link">Agent Dashboard</Link>}
      {isArtist && !isAdmin && !isAgent && <Link to="/artist-dashboard" className="text-sm text-[#A1A1AA] hover:text-white transition-colors" data-testid="nav-artist-dashboard-link">Artist Dashboard</Link>}
      {(!isArtist || isAdmin) && !isAgent && <Link to={isAdmin ? "/admin?tab=artists" : "/artists"} className="text-sm text-[#A1A1AA] hover:text-white transition-colors" data-testid="nav-browse-artists">Browse Artists</Link>}
      {isArtist && !isAdmin && !isAgent && (
        <Link to="/studio" className="text-sm font-bold text-lime hover:text-white transition-colors inline-flex items-center gap-1.5" data-testid="nav-studio">
          <Mic2 className="w-3.5 h-3.5" />
          STUDIO
        </Link>
      )}
      {!isArtist && !isAdmin && !isAgent && (
        <Link to="/weekly-specials" className="text-sm text-[#A1A1AA] hover:text-white transition-colors inline-flex items-center gap-1" data-testid="nav-weekly-specials">
          <Sparkles className="w-3.5 h-3.5 text-lime" />
          Weekly Specials
        </Link>
      )}
      {!isAdmin && !isAgent && <Link to="/about" className="text-sm text-[#A1A1AA] hover:text-white transition-colors">About Us</Link>}
      {!isAdmin && !isAgent && <Link to="/faq" className="text-sm text-[#A1A1AA] hover:text-white transition-colors" data-testid="nav-faq">FAQ</Link>}

      {isAuthenticated ? (
        <>
          {showCart && (
            <Link to="/cart" className="relative" data-testid="nav-cart">
              <ShoppingCart className="w-5 h-5 text-[#A1A1AA] hover:text-white transition-colors" />
              {cart.item_count > 0 && (
                <span className="absolute -top-2 -right-2 w-5 h-5 bg-lime text-black text-xs rounded-full flex items-center justify-center font-bold">{cart.item_count > 9 ? '9+' : cart.item_count}</span>
              )}
            </Link>
          )}

          {!isAgent && (
            <Link to={`${dashboardLink}?tab=inbox`} className="relative" data-testid="nav-inbox-bell">
              <MessageCircle className="w-5 h-5 text-[#A1A1AA] hover:text-white transition-colors" />
              {inboxCount > 0 && (
                <span className="absolute -top-1 -right-1 w-4 h-4 bg-lime text-black text-[10px] rounded-full flex items-center justify-center font-bold">{inboxCount}</span>
              )}
            </Link>
          )}

          <Link to={`${dashboardLink}?tab=notifications`} className="relative" data-testid="nav-notif-bell">
            <Bell className="w-5 h-5 text-[#A1A1AA] hover:text-white transition-colors" />
            {notifCount > 0 && (
              <span className="absolute -top-1 -right-1 w-4 h-4 bg-red-500 text-white text-[10px] rounded-full flex items-center justify-center font-bold">{notifCount > 9 ? '9+' : notifCount}</span>
            )}
          </Link>

          <UserDropdown user={user} isAdmin={isAdmin} isArtist={isArtist} isAgent={isAgent} onLogout={onLogout} />
        </>
      ) : (
        <div className="flex items-center gap-4">
          <Link to="/login" className="text-sm text-[#A1A1AA] hover:text-white transition-colors" data-testid="nav-login">Login</Link>
          <Link to="/register" className="btn-primary text-sm py-2 px-4" data-testid="nav-register">Sign Up</Link>
        </div>
      )}
    </div>
  );
}
